import { DueTag } from "./DueDate";
import { ageLabel, isOverdue } from "./format";
import { useSpaceParam, useTasks, useTrashTask, useUpdateTask } from "./hooks";

/** `someday` = maybe later; the only actions are "activate" and "bin". */
export function SomedayView() {
  const space = useSpaceParam();
  const { data, isLoading, error } = useTasks({ status: ["someday"], space, limit: 200 });
  const update = useUpdateTask();
  const trash = useTrashTask();

  return (
    <div className="view">
      {isLoading && <p className="muted">Ładowanie…</p>}
      {error && <p className="error">Nie udało się pobrać listy.</p>}
      {data && data.items.length === 0 && <p className="muted">Lista „kiedyś” jest pusta.</p>}

      <ul className="rows">
        {data?.items.map((task) => (
          <li key={task.id} className={`row ${isOverdue(task) ? "row--overdue" : ""}`}>
            <div className="row__main">
              <span className="row__title">{task.title}</span>
              <span className="row__meta">
                <span>{ageLabel(task.created_at)}</span>
                {task.context && <span>{task.context}</span>}
                <DueTag task={task} />
              </span>
            </div>
            <div className="row__actions">
              <button
                className="btn btn--small"
                title="Przenieś do next actions"
                onClick={() => update.mutate({ id: task.id, input: { status: "next" } })}
              >
                → next
              </button>
              <button
                className="btn btn--small btn--danger"
                title="Do kosza"
                onClick={() => trash.mutate(task.id)}
              >
                🗑
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
